<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t("content.gmovement") }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-12">
                <span class="form-label m-0">{{ $t("content.select") }}</span>
                <!-- จำนวนตั๋ว -->
                <div class="d-inline-block mx-4">
                  <material-checkbox 
                    v-model="selnumTk" :checked="selnumTk"
                  >
                    {{ $t("content.amtk") }}
                  </material-checkbox>
                </div>

                <!-- มูลค่ารวม -->
                <div class="d-inline-block me-4">
                  <material-checkbox 
                    v-model="selAmount"  :checked="selAmount"
                  >
                    {{ $t("content.amntotalval") }}
                  </material-checkbox>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>{{ $t("content.item") }}</th>
                      <th class="text-center">{{ $t("content.more12m") }}</th>
                      <th v-for="month in dynamicMonths" :key="month.Value" class="text-center">
                        {{ month.Label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- แถวข้อมูลปกติ -->
                    <tr v-for="(row, index) in rows" :key="index">
                      <td class="text-left">{{ row.name }}</td>
                      <td v-for="mKey in ['00000', ...dynamicMonths.map(m => m.Value)]" :key="mKey" class="text-center">
                        
                        <!-- บรรทัดบน: จำนวนตั๋ว (ซ่อนถ้าเป็น 0) -->
                        <div v-if="selnumTk && apiData?.[mKey]?.[row.apiKey]">
                          <span 
                            v-if="row.apiKey !== 'inout'"
                            class="font-weight-bold" 
                            style="cursor:pointer; text-decoration:underline; color: blue;"
                            @click="mKey !== '00000' ? goToHistory(mKey, row) : null"
                          >
                            {{ fmNumber(apiData?.[mKey]?.[row.apiKey]) }}
                          </span>
                          <span v-else>{{ fmNumber(apiData?.[mKey]?.[row.apiKey]) }}</span>
                        </div>

                        <!-- บรรทัดล่าง: มูลค่า (ซ่อนถ้าเป็น 0) -->
                        <div v-if="selAmount && apiData?.[mKey]?.[row.apiValueKey]">
                          <!-- กรณีเลือกทั้งคู่: ใส่ในวงเล็บ กดไม่ได้ -->
                          <template v-if="selnumTk">
                            <small class="text-muted">
                              ({{ fmNumber(apiData?.[mKey]?.[row.apiValueKey]) }})
                            </small>
                          </template>

                          <!-- กรณีเลือกมูลค่าอย่างเดียว: ตัวหนา กดได้ -->
                          <template v-else>
                            <span 
                              v-if="row.apiKey !== 'inout'"
                              class="font-weight-bold" 
                              style="cursor:pointer; text-decoration:underline; color: blue;"
                              @click="mKey !== '00000' ? goToHistory(mKey, row) : null"
                            >
                              {{ fmNumber(apiData?.[mKey]?.[row.apiValueKey]) }}
                            </span>
                            <span v-else>{{ fmNumber(apiData?.[mKey]?.[row.apiValueKey]) }}</span>
                          </template>
                        </div>
                      </td>
                    </tr>

                    <!-- แถวพิเศษ: % ของผลัด -->
                    <tr class="table-secondary font-weight-bold">
                      <td class="text-left">% ของผลัด</td>
                      <td v-for="mKey in ['00000', ...dynamicMonths.map(m => m.Value)]" :key="mKey" class="text-center">
                        <div v-if="selnumTk">
                          {{ calculatePercent(apiData?.[mKey]?.postpone, apiData?.[mKey]?.pawn) }}
                        </div>
                        <div v-if="selAmount" :class="{'text-muted small': selnumTk}">
                          {{ calculatePercent(apiData?.[mKey]?.postponeValue, apiData?.[mKey]?.pawnValue, selnumTk) }}
                        </div>
                      </td>
                    </tr>

                    <!-- แถวพิเศษ: % ของหลุด -->
                    <tr class="table-secondary font-weight-bold">
                      <td class="text-left">% ของหลุด</td>
                      <td v-for="mKey in ['00000', ...dynamicMonths.map(m => m.Value)]" :key="mKey" class="text-center">
                        <div v-if="selnumTk">
                          {{ calculatePercent(apiData?.[mKey]?.breaking, apiData?.[mKey]?.pawn) }}
                        </div>
                        <div v-if="selAmount" :class="{'text-muted small': selnumTk}">
                          {{ calculatePercent(apiData?.[mKey]?.breakingValue, apiData?.[mKey]?.pawnValue, selnumTk) }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>


              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

import { useStockMovementStore } from '@/stores/stockmovement';

const storest = useStockMovementStore()

const { t } = useI18n();
const swal = inject("$swal");
const apiData = ref({});
const rows = [
  { name: 'จำนำ', apiKey: 'pawn', apiValueKey: 'pawnValue' },
  { name: 'ต่อดอก', apiKey: 'interest', apiValueKey: 'interestValue' },
  { name: 'เพิ่มต้น', apiKey: 'incPrinciple', apiValueKey: 'incValue' }, // แก้เป็น incValue
  { name: 'ลดต้น', apiKey: 'decPrinciple', apiValueKey: 'decValue' }, // แก้เป็น decValue
  { name: 'ไถ่ถอน (ทำธุรกรรมใหม่)', apiKey: 'redeemNewTx', apiValueKey: 'redeemNewTxValue' },
  { name: 'ไถ่ถอนจริง', apiKey: 'redeem', apiValueKey: 'redeemValue' },
  { name: 'จำนวนตั๋วที่เหลือตามวันที่ทำธุรกรรมของเดือนนั้นๆ', apiKey: 'remaining', apiValueKey: 'remainValue' }, // แก้เป็น remainValue
  { name: 'จำนวนตั๋วที่เข้าออกของเดือนนั้นๆ', apiKey: 'inout', apiValueKey: 'inoutValue' },
  { name: 'อายัด', apiKey: 'freeze', apiValueKey: 'freezeValue' },
  { name: 'ของผลัด', apiKey: 'postpone', apiValueKey: 'postponeValue' },
  { name: 'ของหลุด', apiKey: 'breaking', apiValueKey: 'breakingValue' },
];

const selnumTk = ref(true);
const selAmount = ref(false);

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const dynamicMonths = computed(() => {
  const months = [];
  const now = new Date();
  for (let i = 11; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = `${d.toLocaleString('th-TH', { month: 'short' })}-${d.getFullYear().toString().slice(-2)}`;
    const monthVal = d.getMonth() + 1;
    const value = `${d.getFullYear()}${monthVal.toString().padStart(2, '0')}`;
    months.push({ Label: label, Value: value });
  }
  return months;
});

const calculatePercent = (part, total, useBrackets = false) => {
  if (!total || total == 0 || !part || part == 0) return '';
  const result = (part / total) * 100;
  if (result === 0) return '';
  
  const formatted = result.toLocaleString(undefined, { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  }) + '%';
  
  return useBrackets ? `(${formatted})` : formatted;
};

const fmNumber = (val) => {
  if (val === undefined || val === null || val === 0) return '';
  return Number(val).toLocaleString(undefined, { 
    minimumFractionDigits: val % 1 === 0 ? 0 : 2, 
    maximumFractionDigits: 2 
  });
};

const loadDataReportApi = async () => {
  apiData.value = {}
  let data = "";

  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storest.txSummaryFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
            if (response.data && response.data.data) {
              apiData.value = response.data.data;
            } 
      }
    }
  }
}

loadDataReportApi()



const goToHistory = (monthValue, row) => {
  const start = moment(monthValue, "YYYYMM").startOf('month').format('YYYY-MM-DDT00:00:00');
  const end = moment(monthValue, "YYYYMM").endOf('month').format('YYYY-MM-DDT23:59:59');

  const valueMap = {
    'pawn': 3, 'interest': 4, 'incPrinciple': 5, 'decPrinciple': 6, 'redeem': 7,
    'redeemNewTx': 21, 'remaining': 22, 'freeze': 23, 'postpone': 24, 'breaking': 25
  };

  const data = {
    start_date: start,
    end_date: end,
    value: valueMap[row.apiKey] || 0
  };

  sessionStorage.removeItem('historyPage');
  sessionStorage.setItem("historyPage", JSON.stringify(data));
  window.location.assign("#/generals/history");
};

</script>
  
<style lang="scss" scoped>

</style>